import { render, staticRenderFns } from "./ResponsibilityAssignmentCard.vue?vue&type=template&id=ef5fcd62"
import script from "./ResponsibilityAssignmentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityAssignmentCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityAssignmentCard.vue?vue&type=style&index=0&id=ef5fcd62&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports